module.exports = __webpack_public_path__ + "bg_1.ad1bd328de8b24f4d4ec.jpg";


//////////////////
// WEBPACK FOOTER
// G:/Projekty/swaythegame/src/assets/images/bg_slider/bg_1.jpg
// module id = ../../../../../src/assets/images/bg_slider/bg_1.jpg
// module chunks = styles